import { BootstrapBrowserBuilder } from '@zg-rentals/rp-bootstrap-browser';
import { analytics } from '../analytics';

export const bootstrap = new BootstrapBrowserBuilder('zillow-rental-manager-web-next', Number(process.env.BUILD_NUMBER))
  .withHostedAppLoggerOptions('rental-manager-api', process.env.NEXT_PUBLIC_LOG_LEVEL)
  .withOnRegister(analytics.initialize)
  .build();
